'use client';

import dynamic from 'next/dynamic';

import { useAppSelector } from '@/app/lib/store/hooks';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { APP_URLS } from '@/app/lib/constants/app-urls';
import { LOGO_HEIGHT } from '@/app/lib/constants/sizes';
import { Box } from '@radix-ui/themes';
import { getFeatureFlagCached } from '@/app/lib/redis/cacheService';
import TabletHeader from '../components/header/tablet-header';

const MobileHeader = dynamic(
  () => import('../components/header/mobile-header'),
  {
    ssr: false
  }
);

const DesktopHeader = dynamic(
  () => import('../components/header/desktop-header'),
  {
    ssr: false
  }
);

const HeaderContainer = () => {
  const router = useRouter();
  const isAtTop = useAppSelector(state => state.scroll.isAtTop);
  const isOpen = useAppSelector(state => state.drawer.isOpen);

  const theme = useAppSelector(state => state.theme.mode);

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const user = useAppSelector(state => state.user.data);

  const handleSubscribe = () => {
    router.push(APP_URLS.signUpChoosePlanUrl);
  };
  const handleLogin = () => {
    router.push('/auth');
  };

  const logoHeight = LOGO_HEIGHT.header;

  const [isAuthEnabled, setIsAuthEnabled] = useState(false);

  useEffect(() => {
    const getAuthFeatureFlag = async () => {
      const demoMode = await getFeatureFlagCached('demo-mode');
      setIsAuthEnabled(!demoMode.enabled);
    };
    getAuthFeatureFlag();
  }, []);

  return (
    <>
      <Box display={{ initial: 'block', sm: 'none' }}>
        <MobileHeader
          isAtTop={isAtTop}
          isOpen={isOpen}
          isClient={isClient}
        />
      </Box>
      <Box display={{ initial: 'none', sm: 'block', md: 'none' }}>
        <TabletHeader
          isAtTop={isAtTop}
          user={user}
          isClient={isClient}
          onSubscribe={handleSubscribe}
          onLogin={handleLogin}
          theme={theme}
          logoHeight={logoHeight}
          isAuthEnabled={isAuthEnabled}
          isOpen={isOpen}
        />
      </Box>
      <Box display={{ initial: 'none', md: 'block' }}>
        <DesktopHeader
          isAtTop={isAtTop}
          user={user}
          isClient={isClient}
          onSubscribe={handleSubscribe}
          onLogin={handleLogin}
          theme={theme}
          logoHeight={logoHeight}
          isAuthEnabled={isAuthEnabled}
        />
      </Box>
    </>
  );
};

export default HeaderContainer;
